import { AnyObject, UnknownObject } from '@truvity/js-core__utils';
import { IFormDef } from '@truvity/widget__forms';
import { createTsDefinition, jsToJson, jsonToJs, assertSupportedJsonSchema } from '@truvity/widget__json-schema';
import { useEffect, useState } from 'react';

type State =
    | { state: 'loading' }
    | { state: 'error'; error: unknown }
    | {
          state: 'loaded';
          schema: IFormDef;
          jsToJson: (claims: AnyObject) => UnknownObject;
          jsonToJs: (claims: AnyObject) => UnknownObject;
      };

type UseCredentialSchemaOptions = {
    getJsonSchema: () => Promise<AnyObject>;
    onError?: (err: unknown) => void;
};

export function useCredentialSchema({ getJsonSchema, onError }: UseCredentialSchemaOptions) {
    const [state, setState] = useState<State>({ state: 'loading' });

    useEffect(() => {
        let isRelevant = true;

        (async () => {
            setState({ state: 'loading' });

            try {
                const schema = await getJsonSchema();

                if (!isRelevant) return;

                assertSupportedJsonSchema(schema);

                const defs = createTsDefinition(schema);

                setState({
                    state: 'loaded',
                    schema: defs,
                    jsToJson: (claims) => jsToJson(schema, claims),
                    jsonToJs: (claims) => jsonToJs(schema, claims),
                });
            } catch (error) {
                if (!isRelevant) return;
                onError?.(error);
                setState({ state: 'error', error });
            }
        })();

        return () => {
            isRelevant = false;
        };
    }, [onError, getJsonSchema]);

    return state;
}
